export default __webpack_public_path__ + "static/media/iso.9b39314e.png";